import { Formik } from "formik";
import React from "react";
import DivisionCmp from "../../components/cards/DivisionCmp";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import { Grid } from "@mui/material";
import * as Yup from "yup";
import Button from "@mui/material/Button";
import SwitchCmp from "../../components/switch/SwitchCmp";
import { SupplierUserRequest } from "../../models/supplierUser.model";
import { CreateSupplierUser } from "../../services/supplierUser.service";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { getTokenClaims } from "../../services/auth.service";
import ErrorPage from "../errorPage/errorPage";

function UserRegistration_() {
  const [submitFlag, setSubmitFlag] = React.useState<boolean>(true);
  const [isActive, setIsActive] = React.useState<boolean>(false);
  const [isSuperUser, setIsSuperUser] = React.useState<boolean>(false);
  const [selectedCount, setSelectedPart] = React.useState();
  const history = useHistory();
  const yupMax = 10;
  const yupMobileMax = 11;
  const formValid = Yup.object().shape({
    nationalCode: Yup.string()
      .required("فیلد اجباری می باشد")
      .matches(/^[0-9]+$/, "شماره ملی فقط عدد می باشد")
      .min(yupMax, "شماره ملی ده رقم است")
      .max(yupMax, "شماره ملی فقط ده عدد است"),
    firstName: Yup.string().required("فیلد اجباری می باشد"),
    lastName: Yup.string().required("فیلد اجباری می باشد"),
    mobileNumber: Yup.string().required("فیلد اجباری می باشد"),
  });
  const nationalCodeHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;
    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
    if (
      event.target.value.length >= yupMax &&
      key != 8 &&
      key != 46 &&
      selectedCount === 0
    ) {
      event.preventDefault();
    }
  };
  const mobileNumberCodeHandleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;
    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
    if (
      event.target.value.length >= yupMobileMax &&
      key != 8 &&
      key != 46 &&
      selectedCount === 0
    ) {
      event.preventDefault();
    }
  };
  const handleKeyDown = (event: any) => {
    var key = event.keyCode ? event.keyCode : event.which;

    if (!/[0-9]/.test(event.key) && key != 8 && key != 46) {
      event.preventDefault();
    }
  };
  const currentSelection = (e: any) => {
    setSelectedPart(
      e.target.value.substring(e.target.selectionStart, e.target.selectionEnd)
        .length
    );
  };

  const CreateSupplierUserMutation = useMutation(CreateSupplierUser, {
    onSuccess: (data: boolean) => {
      if (data === true) {
        history.push(`/setting/supplierUsers`);
      }
    },
    onError: () => {
      setSubmitFlag(true);
    },
  });
  const backClick = () => {
    history.push("/setting/supplierUsers");
  };
  return (
    <>
      <Formik
        initialValues={new SupplierUserRequest()}
        validateOnMount={true}
        validationSchema={formValid}
        onSubmit={async (values) => {
          // if (submitFlag) {
          setSubmitFlag(false);
          // queryClient.setQueryData(NATIONAL_CODE, values.nationalCode);
          values.isActive = isActive;
          values.isSuperUser = isSuperUser;
          await CreateSupplierUserMutation.mutateAsync(values);
          // }
        }}
      >
        {({
          handleSubmit,
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
        }) => (
          <form
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            <div style={{ paddingRight: "36px", paddingTop: "15px" }}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 10, lg: 12 }}
                style={{ paddingTop: "30px" }}
              >
                <Grid item xs={3}>
                  <MaterialTextFieldComponent
                    autoFocus={true}
                    helperText={touched.firstName ? errors.firstName : ""}
                    error={touched.firstName && Boolean(errors.firstName)}
                    value={values.firstName}
                    placeHolder={"*نام"}
                    label={"*نام"}
                    required={true}
                    name="firstName"
                    id="firstName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // onKeyDown={handleKeyDown}
                    // onSelect={currentSelection}
                  />
                </Grid>

                <Grid item xs={3}>
                  <MaterialTextFieldComponent
                    helperText={touched.lastName ? errors.lastName : ""}
                    error={touched.lastName && Boolean(errors.lastName)}
                    value={values.lastName}
                    placeHolder={"*نام خانوادگی"}
                    label={"*نام خانوادگی"}
                    required={true}
                    name="lastName"
                    id="lastName"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    // onKeyDown={handleKeyDown}
                    // onSelect={currentSelection}
                  />
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={3}>
                  <MaterialTextFieldComponent
                    helperText={touched.nationalCode ? errors.nationalCode : ""}
                    error={touched.nationalCode && Boolean(errors.nationalCode)}
                    value={values.nationalCode}
                    placeHolder={"*کد ملی "}
                    label={"*کد ملی "}
                    required={true}
                    name="nationalCode"
                    id="nationalCode"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onKeyDown={nationalCodeHandleKeyDown}
                    onSelect={currentSelection}
                  />
                </Grid>

                <Grid item xs={3}>
                  <MaterialTextFieldComponent
                    helperText={touched.mobileNumber ? errors.mobileNumber : ""}
                    error={touched.mobileNumber && Boolean(errors.mobileNumber)}
                    value={values.mobileNumber}
                    placeHolder={"*شماره موبایل"}
                    label={"*شماره موبایل"}
                    required={true}
                    name="mobileNumber"
                    id="mobileNumber"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    onKeyDown={mobileNumberCodeHandleKeyDown}
                    onSelect={currentSelection}
                  />
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={3}>
                  <SwitchCmp
                    Label={"دسترسی کاربر"}
                    checked={isActive}
                    onChange={(checked: boolean) => {
                      setIsActive(checked);
                    }}
                    onlabel={"فعال"}
                    offlabel={"غیرفعال"}
                    colSize="col-lg-6 col-6"
                  />
                </Grid>

                <Grid item xs={3}>
                  <SwitchCmp
                    Label={" کاربر سطح بالا"}
                    checked={isSuperUser}
                    onChange={(checked: boolean) => {
                      setIsSuperUser(checked);
                    }}
                    onlabel={"بله"}
                    offlabel={"خیر"}
                    colSize="col-lg-6 col-6"
                  />
                </Grid>
                <Grid item xs={6}></Grid>
                <Grid item xs={12}></Grid>
              </Grid>
              <Grid
                item
                xs={3}
                sm={2}
                md={1}
                style={{ textAlign: "left", margin: "40vh 0 10px 30px" }}
              >
                {/* <Button className="btnForm primaryDefault  marginRight-12 " type="submit" style={{color: !isValid? "#e6123d":  "#28a745"}} disabled={!isValid} >تایید و ادامه</Button> */}
                <Button
                  type="submit"
                  disabled={Object.keys(errors).length > 0 && submitFlag}
                  className={`${
                    Object.keys(errors).length > 0
                      ? "btnForm disabledBtn  "
                      : "btnForm SuccessDefault "
                  }`}
                  style={{ width: "120px", marginLeft: "1vh" }}
                >
                  ثبت
                </Button>
                <Button
                  className="btnForm ComingBack"
                  style={{ width: "120px", marginLeft: "1vh" }}
                  onClick={backClick}
                >
                  بازگشت
                </Button>
              </Grid>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}

function AccessUserRegistration() {
  const child = <UserRegistration_ />;
  return (
    <div className="devForDevisionCard">
      <DivisionCmp title="ثبت کاربر جدید" child={child} />
    </div>
  );
}
export default function UserRegistration() {
  const canModifyUser = String(getTokenClaims()?.canModifyUser);
  return (
    <>
      {" "}
      {canModifyUser !== "True" ? <AccessUserRegistration /> : <ErrorPage />}
    </>
  );
}
